import { motion, useReducedMotion } from 'framer-motion';

export default function HandDrawnUnderline({
  color = '#D63AB4',
  className = '',
  width = '100%',
  delay = 0,
}) {
  const prefersReducedMotion = useReducedMotion();

  return (
    <motion.svg
      aria-hidden="true"
      viewBox="0 0 520 24"
      fill="none"
      preserveAspectRatio="none"
      className={className}
      initial={prefersReducedMotion ? false : { opacity: 0 }}
      animate={prefersReducedMotion ? false : { opacity: 1 }}
      transition={{ duration: 0.2, delay }}
      style={{ width }}
    >
      <motion.path
        d="M8 17 C 130 5, 380 3, 512 15"
        stroke={color}
        strokeWidth="5.75"
        strokeLinecap="round"
        fill="none"
        initial={
          prefersReducedMotion
            ? false
            : { pathLength: 0, pathOffset: 0.01 }
        }
        animate={
          prefersReducedMotion
            ? false
            : { pathLength: 1, pathOffset: 0 }
        }
        transition={{
          duration: 0.85,
          delay,
          ease: [0.22, 1, 0.36, 1],
        }}
      />
    </motion.svg>
  );
}
